import { Pencil, Save } from "lucide-react";
import {
  Text,
  Button,
  ButtonVariant,
  TextField,
  Tooltip,
  TextFieldVariant,
} from "@merge-api/merge-javascript-shared";
import Markdown from "markdown-to-jsx";
import { useState } from "react";

interface Props {
  stepNoteText: string;
  setStepNoteText: (x: string) => void;
}
const StepNoteEditorAndViewer = ({ stepNoteText, setStepNoteText }: Props) => {
  const [editedText, setEditedText] = useState<string>("");
  const [isEditing, setIsEditing] = useState(false);

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row items-center justify-between">
        <Text variant="h5">Notes</Text>
        <Tooltip title="Edit notes" className={isEditing ? "invisible" : ""}>
          <Button
            size="sm"
            variant={ButtonVariant.IconShadowHidden}
            onClick={() => {
              setIsEditing(true);
              setEditedText(stepNoteText);
            }}
          >
            <Pencil size={16} />
          </Button>
        </Tooltip>
      </div>
      <hr />
      <div className="flex flex-col flex-grow">
        {isEditing ? (
          <TextField
            multiline
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
            rows={15}
            variant={TextFieldVariant.BorderedCode}
          />
        ) : (
          <Markdown className="pb-6 prose prose-sm">{stepNoteText || "No notes"}</Markdown>
        )}
      </div>

      {isEditing && (
        <div className="flex flex-row gap-x-3 justify-end mt-3">
          <Button
            variant={ButtonVariant.SecondaryGray}
            size="sm"
            onClick={() => {
              setIsEditing(false);
            }}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            disabled={!editedText}
            onClick={() => {
              setStepNoteText(editedText);
              setIsEditing(false);
            }}
            leftIcon={<Save size={14} />}
          >
            Save changes
          </Button>
        </div>
      )}
    </div>
  );
};

export default StepNoteEditorAndViewer;
